import React, {Component} from 'react';
import {Link} from 'react-router-dom';

class Navbar extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <header className="navbar navbar-default navbar-static-top" role="navigation">
                <div className="container-fluid">
                    <div className="navbar-header">
                        <Link className="navbar-brand" to="/">
                            <img
                                className="navbar-logo"
                                src={`${DJ_CONST.STATIC_URL}/images/logo/yhistransport_logo_2017.svg`}
                                alt="Tallinna ühistransport"
                                title="Tallinna ühistransport"
                            />
                            <span className="navbar-brand-text">Tallinna ühistransport</span>
                        </Link>
                    </div>
                    <div id="navbar" className="navbar-collapse collapse">
                        <ul className="nav navbar-nav">
                        </ul>
                        <ul className="nav navbar-nav navbar-right">

                        </ul>
                    </div>
                </div>
            </header>
        );
    }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js